import localForage from "localforage";

localForage.config({
  driver: [localForage.INDEXEDDB, localForage.WEBSQL, localForage.LOCALSTORAGE], // Force WebSQL; same as using setDriver()
  name: "myDemoApp",
  version: 1.0,
  size: 20971520, // Size of database, in bytes. WebSQL-only for now.
  storeName: "DEMO_APP", // Should be alphanumeric, with underscores.
  description: "My demo app",
});

export const calculateStorageSize = async () => {
  let totalSize = 0;
  try {
    await localForage.iterate((key) => {
      var length = (key && key.length) || 0;
      totalSize += length;
    });
    const totalSizeinMB = (totalSize * 2) / 1024 / 1024;
    console.log(`TOTAL SIZE USED - ${totalSizeinMB.toFixed(2)} MB`);
  } catch (err) {
    console.log("error getting size", err);
  }
};

export const clearStorage = async () => {
  await localForage.clear();
};

export const getStorage = async (type) => {
  let items;
  try {
    const localItems = await localForage.getItem(type);
    if (localItems) {
      items = JSON.parse(localItems);
    }
  } catch (err) {
    console.log("error getting item", err);
  }
  return items;
};

export const setStorage = async (type, items) => {
  try {
    await localForage.setItem(type, JSON.stringify(items));
  } catch (err) {
    console.log("storage limit exceeded", err);
  }
};

export const removeItem = async (item) => {
  try {
    await localForage.removeItem(item);
  } catch (err) {
    console.log("error removing item", err);
  }
};
